

















/* Created- 03 - Apr - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ParticaRowContainer from "@/Ui-Components/Common/Container/ParticaRowContainer.vue";
import ArticleSearch from "@/Views/Articles/ArticleSearch.vue";

import ParticaCard from "@/Ui-Components/Common/Container/ParticaCardXL.vue";
import { eParticaAction, getActionName, ParticaEvent } from "../../Models/ParticaEvent";
import { ContentSearchHit } from "../../Generated/ParticaAPI";
import ArticleActions from "@/Ui-Components/Article/Actions/ArticleActions.vue";
import ParticaDialogCard from "@/Ui-Components/Common/Container/ParticaDialogCard.vue";
import ParticaTitleBase from "../Base/ParticaTitleBase.vue";

const namespace: string = "config";

@Component(
	{
		name: "PublicationArticles",
		components: {
			ParticaRowContainer,
			ParticaCard,
			ArticleSearch,
			ArticleActions,
			ParticaDialogCard
		}
	})
export default class PublicationArticles extends ParticaTitleBase {
	@Prop() private id: number;
	@Prop() private articletype: string;
	private query: string = "";
	private selectedArticle: ContentSearchHit = new ContentSearchHit();
	private showactions: boolean = false;
	private facets: string[] = [
		"issue",
		"article_type"
	];


	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ARTICLE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					this.showactions = true;
					break;
				}
				case eParticaAction.CLOSE_DIALOG: {
					this.showactions = false;
					break;
				}
				case eParticaAction.ISSUE_SELECT: {
					this.selectedArticle = event.item as ContentSearchHit;
					if (this.selectedArticle !== undefined && this.selectedArticle.issueId !== undefined) {
						this.navigate("issue", { id: this.selectedArticle.issueId.toString() });
					}
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}

	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Publication Articles";
		await this.init();

	}

	private async init() {
		try {
			this.LoadingStart();
			await this.getTitleNav(this.id);
		} catch (error) {
			this.ShowErrorDialog(error, "error initializing component.");
		} finally {
			this.LoadingEnd();
		}
	}
}
